import styled from "styled-components";

const Wrapper = styled.div`
  box-shadow: 0 0 12px 0 rgb(0 0 0 / 8%);
  background-color: #ffffff;
  min-height: 249px;
  position: relative;
  -webkit-flex: 1;
  -ms-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
`;
const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px #97979729;
  padding: 0 20px;
  height: 80px;
  h3 {
    text-transform: uppercase;
    font-family: "latobold";
    font-size: 16px;
  }
`;
const SellerInfo = styled.div`
  padding: 0px 15px 0px 23px;
`;
const Reviews = styled.div``;

const PanelWrapperLeft = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: #f9f9f9;
  padding: 20px;
  border-bottom: 10px solid #fff;
  display: grid;
  grid-gap: 10px;
  a {
    margin-left: 10px;
    justify-content: flex-end;
  }
  p {
    display: flex;
  }
  span {
    font-size: 14px;
    display: flex;
    color: #00b2fe;
  }
`;
const PanelWrapperRight = styled.div`
  border-radius: 10px;
  background-color: #dc354536;
  padding: 15px;
  margin: 10px;
  display: flex;
  flex-direction: column;
`;

const ActionBtn = styled.div`
  display: flex;
  justify-content: flex-end;
  a {
    margin-left: 50px;
  }
`;

const Chatbox = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  justifycontent: center;
  alignitems: center;
  z-index: 9;
  background-color: rgba(255, 255, 255, 0.8);
`;

const Chatblock = styled.div`
  padding: 0px 0px 0px 2px;
  text-align: left;
  border-bottom: 1px solid #c5c5c5;
  margin: 5px;
`;

const ChatboxWrapper = styled.div`
  border: 1px solid black;
  border-radius: 5px;
  height: 95%;
  width: 97%;
  padding: 10px;
  background-color: #fff;
  position: absolute;
  margin: 14px;
  textarea {
    &::placeholder {
      padding: 10px;
      color: #5e6265;
      opacity: 1; /* Firefox */
      font-family: "Lato";
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      padding: 10px;
      color: #5e6265;
      font-family: "Lato";
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      padding: 10px;
      color: #5e6265;
      font-family: "Lato";
    }
  }
`;
const ChatBtn = styled.div`
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  color: #080808;
  font-size: 14px;
  cursor: pointer;
  min-height: 27px;
  width: 151px;
  justify-content: center;
  svg {
    margin-right: 10px;
  }
  margin-left: 10px;
`;

const ClaimContainer = styled.div`
`;

const TableWrapper = styled.div`
  border-radius: 15px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
  .admin-claim-subheading {
    display: flex;
    padding: 6px 5px 5px 16px;
    overflow: auto;
    p {
      margin-right: 50px;
      color: #00446e;
      font-family: "latomedium";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
    }
  }
  .admin-claim-subheading::-webkit-scrollbar {
    height: 0px;
  }
  .admin-claim-subheading::-webkit-scrollbar-track {
    background: #d4e2e9;
    border-radius: 5px;
    border: 1px solid #005586;
  }
  .admin-claim-subheading::-webkit-scrollbar-thumb {
    background: #005586;
    border-radius: 5px;
    border: 1px solid #005586;
  }
  .side_bar::-webkit-scrollbar-thumb:hover {
    background: #009eb3;
  }
  .selected {
    border-bottom: solid 3px #459cc3;
  }
`;
const InnerBoxes = styled.div`
  border-radius: 15px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
  background: linear-gradient(180deg, #ffffff 0%, #e9f8ff 100%);
  h3 {
    margin: 21px 0px 2px 15px;
    font-size: 16px;
    line-height: 15px;
    color: #3d91c5;
    font-family: "latomedium";
    font-style: normal;
    font-weight: 700;
    span {
      color: #00446e;
    }
  }
  h6 {
    margin: 21px 0px 2px 15px;
    font-size: 17px;
    line-height: 15px;
    color: #303030;
    font-family: "latomedium";
    font-style: normal;
    font-weight: 700;
  }
  .first-row {
    display: grid;
    grid-template-columns: 5fr 1fr;
    padding: 6px 0px 5px 16px;
    border-bottom: solid 1px #c0c0c0;
    button {
      border-radius: 5px;
      border: none;
      color: #ffffff;
      background: #5ea8ca;
      height: 32px;
      width: 136px;
    }
    p {
      margin-right: 28px;
      color: #303030;
      font-family: "latomedium";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      span {
        color: #00446e;
      }
    }
    h4 {
      margin-right: 28px;
      color: #00446e;
      font-family: "latomedium";
      font-style: normal;
      font-size: 16px;
      line-height: 54px;
      white-space: nowrap;
      cursor: pointer;
      i {
        border: solid #00446e;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
        margin: 0px 0px -2px 3px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      margin-right: 28px;
      color: #00446e;
      font-family: "latomedium";
      font-style: normal;
      font-size: 16px;
      line-height: 54px;
      white-space: nowrap;
      cursor: pointer;
      i {
        border: solid #00446e;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
        margin: 2px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
  .second-row {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(205px, 1fr));
    padding: 6px 0px 5px 16px;
    p {
      margin-right: 10px;
      color: #303030;
      font-family: "latomedium";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      span {
        color: #00446e;
      }
    }
  }
  .third-row {
    display: flex;
    padding: 15px 16px 10px 16px;
    justify-content: space-between;
    button {
      margin-right: 10px;
      margin-bottom: 5px;
      border-radius: 5px;
      border: none;
      color: #ffffff;
      background: #5ea8ca;
    }
    div {
      button:nth-child(5){
        background: #b11212;
      }
    }
  }
  .detail-section {
    display: flex;
    flex-direction: column;
    padding: 6px 16px 0px 16px;
    p{
      margin: 2px 0;
    }
    div {
      display: flex;
      p:first-child {
        font-weight: bold;
        width: 191px;
      }
    }
    @media (max-width: 465px){
      div {
        p:first-child {
          width: 125px;
        }
      }
    }
  }
  .detail-section-mobile-view-two {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    width: 300px;
    p {
      :first-child {
        font-weight: normal !important;
      }
    }
    @media (max-width: 465px){
      max-width: 125px;;
    }
  }
  .chat-section{
    display: flex;
    justify-content: flex-end;
    position: relative;    
  }
  @media (max-width: 1094px) {
    .detail-section-mobile-view-one {
      display: grid !important;
    }
  }
  @media (max-width: 767px) {
    .first-row, .second-row, .third-row{
      padding: 8px 6px;
      h5, h4{
        font-size: 14px;
      }
    }
    .chat-section{
      display: block;
      margin: 10px;
    }
  }
  @media (max-width: 465px) {
    .first-row, .second-row, .third-row{
      h5, h4{
        font-size: 12px;
      }
      button{
        margin: 5px;
      }
    }
  }
`;

const InnerBoxesRefund = styled.div`
  border-radius: 15px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
  background: linear-gradient(180deg, #ffffff 0%, #e9f8ff 100%);
  h3 {
    margin: 21px 0px 2px 15px;
    font-size: 16px;
    line-height: 15px;
    color: #3d91c5;
    font-family: "latomedium";
    font-style: normal;
    font-weight: 700;
    span {
      color: #00446e;
    }
  }
  .first-row {
    display: grid;
    grid-template-columns: 5fr 1fr;
    padding: 6px 0px 5px 16px;
    border-bottom: solid 1px #c0c0c0;
    button {
      border-radius: 5px;
      border: none;
      color: #ffffff;
      background: #5ea8ca;
      height: 32px;
      width: 136px;
      @media (max-width: 465px) {
        margin: 5px 0;
      }
    }
    p {
      margin-right: 28px;
      color: #303030;
      font-family: "latomedium";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      span {
        color: #00446e;
      }
    }
    h4 {
      margin-right: 28px;
      color: #00446e;
      font-family: "latomedium";
      font-style: normal;
      font-size: 16px;
      line-height: 54px;
      white-space: nowrap;
      cursor: pointer;
      i {
        border: solid #00446e;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
        margin: 0px 0px -2px 3px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      margin-right: 28px;
      color: #00446e;
      font-family: "latomedium";
      font-style: normal;
      font-size: 16px;
      line-height: 54px;
      white-space: nowrap;
      cursor: pointer;
      i {
        border: solid #00446e;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
        margin: 2px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
  .mobile-resp-first-row{
    display: grid;
    grid-template-columns: minmax(275px, 1fr) minmax(260px, 1fr) minmax(170px, 1fr) minmax(170px, 1fr) minmax(200px, 1fr);
    align-items: center;
    @media (max-width: 1500px) {
      grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  }
  }
  .refund-second-row {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    padding: 6px 0px 5px 16px;
    p {
      margin-right: 10px;
      color: #303030;
      font-family: "latomedium";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      span {
        color: #00446e;
      }
    }
  }
  .second-row{    
    padding: 6px 0px 5px 16px;
    h1{
      margin-right: 28px;
      color: #3D91C5;
      font-family: "latomedium";
      font-style: normal;
      font-size: 16px;
      font-weight: bold;
      line-height: 30px;
      white-space: nowrap;
      span{
        color: #00446E;
        margin-left: 10px;
        font-size: 15px;
      }
    }
    div{
      div{
        display: flex;
        align-items: center;
        margin-bottom: 0px;
        p, span {
          margin-right: 28px;
          font-family: "latomedium";
          font-style: normal;
          font-size: 16px;
          line-height: 15px;
          white-space: nowrap;
        }
        p{
          font-weight: bold;          
          width: 160px;
        }
      }
    }
  }
  .third-row {
    display: flex;
    padding: 15px 16px 10px 16px;
    justify-content: space-between;
    button {
      margin-right: 10px;
      margin-bottom: 5px;
      border-radius: 5px;
      border: none;
      color: #ffffff;
      background: #5ea8ca;
    }    
    div {
      button:nth-child(2){
        background: #b11212;
      }
    }
  }
`;


const ResolutionModalInnerBoxes = styled.div`
  border-radius: 4px 4px 8px 8px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #e9f8ff 100%);
  p {
    text-align: center;
    font-size: 18px;
  }
  .exchange-modal-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    h1 {
      font-size: 20px;
    }
    img {
      height: 28px;
      width: 28px;
      cursor: pointer;
    }
  }
`;

const ClaimInfoSection = styled.div`
  .claim-info-section {
    border: 1px solid #d5cccc;
    border-radius: 5px;
    padding: 0px 0px 0px 10px;
  }
  h6 {
    color: #3d91c5;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    padding-top: 7px
  }
  .claim-info {
    display: flex;
    flex-direction: column;
    padding: 5px 14px 2px 0px;
    p{
      margin: 2px 0;
    }
    div {
      display: flex;
      p:first-child {
        width: 210px;
      }
    }
  }
  span {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
  }
`;

const AdjustRefundSection = styled.div`
  .claim-info-section {
    border: 1px solid #d5cccc;
    border-radius: 5px;
    padding: 0px 0px 0px 10px;
  }
  h6 {
    color: #3d91c5;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    padding-top: 7px
  }
  .claim-info {
    display: flex;
    flex-direction: column;
    padding: 5px 14px 2px 0px;
    p{
      margin: 2px 0;
    }
    hr{
      margin : 5px 0px 5px 0px;
    }
    div {
      display: flex;
      p:first-child {
        width: 210px;
      }
    }
  }
  span {
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
  }
  .app-input-text{
    margin-bottom: 10px !important;
  }
`;

const ProcessWithSection = styled.div`
  .disable-button{
    input{
      background: #d9dbdd;
    }
  }
  .process-with-section {
    background: #ebeced;
    padding: 10px;
  }
  p {
    color: #3d91c5;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 12px;
    margin-top: 7px;
  }
  .process-with {
    display: grid;
    grid-template-columns: 2fr 1fr;
    margin-top: 6px;
    p{
      color: #191819;
    }
  }
  .app-input-text {
    margin-bottom: 0px !important;
  }
`;

const ExchangeDateSection = styled.div`
  .exchange-date-section {
    /* background: #ebeced; */
    border: 1px solid #d5cccc;
    border-radius: 5px;
    padding: 5px 1px 10px 10px;
  }
  p {
    color: #3d91c5;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
  }
  .exchange-info {
    display: grid;
    grid-template-columns: 1fr 2fr;
  }
  @media (max-width:465px){
    .exchange-info{
       grid-template-columns: 2fr 1fr;
    }
  }
`;

const SummarySection = styled.div`
  .summary-section {
    padding: 5px 1px 10px 10px;
    background: #ebeced;
    p{
      color: #3d91c5;
    }
  }
  .light-theme{
    background: none !important;
  }
  h6{
    font-size: 16px;
    margin-bottom: 2px;
    font-weight: bold;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
  }
  .trader-info-section{
    p{
      color:#191819;
    }
  }
  .summary-info {
    display: flex;
    flex-direction: column;
    padding: 5px 14px 2px 0px;
    max-width: 310px
    p{
      margin: 2px 0;
    }
    hr{
      margin: 14px 0px 4px 0px;
    }
    div {
      display: flex;
      height:25px;
      p{        
        color: #191819;
        white-space: nowrap;
      }
      p:first-child {
        width: 191px;
      }
    }
  }
  span {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
  }
  .heading-style{
    font-weight: bold;
    color: #3D91C5;
  }
`;

const ClaimResolutioHeader = styled.div`
  .red-outline{
    border: 2px solid #b11212;
    border-radius: 5px;
  }
  .modal-body {
    padding: 0px !important;
  }
  .confirmation-content {
    background: linear-gradient(180deg, #ffffff 0%, #e9f8ff 100%);
    div {
      display: flex;
      padding: 10px 0px 17px 36%;
    }
    p {
      text-align: center;
      font-size: 18px;
    }
    button {
      border: none;
      margin-right: 10px;
      padding: 5px 15px 5px 15px;
    }
  }
  .no-button {
    background: #6b7173;
    border-radius: 5px;
  }
  .yes-button {
    background: linear-gradient(180deg, #55c416 0%, #367910 100%);
    border-radius: 5px;
  }
`;

const SubmitButtonWrapper = styled.div`
  .submit-button-wrapper {
    text-align: -webkit-center;
    padding: 10px;
  }
`;
export {
  ContentHeader,
  SellerInfo,
  Reviews,
  Wrapper,
  PanelWrapperLeft,
  PanelWrapperRight,
  ActionBtn,
  Chatblock,
  Chatbox,
  ChatboxWrapper,
  ChatBtn,
  ClaimContainer,
  TableWrapper,
  InnerBoxes,
  InnerBoxesRefund,
  ClaimResolutioHeader,
  ResolutionModalInnerBoxes,
  ClaimInfoSection,
  ProcessWithSection,
  SummarySection,
  ExchangeDateSection,
  SubmitButtonWrapper,
  AdjustRefundSection,
};
